module.exports = __webpack_public_path__ + "img/ic_call.b7c3e1fd.svg";